import { RouteObject } from "react-router";
import Account from "@/routes/home/Account";
import { ROUTES } from "@/constants/routes";

export const accountRoutes: RouteObject[] = [
  {
    id: ROUTES.account.id,
    path: "/account",
    element: <Account />,
  },
];
